import type { ButtonVariant } from "../../../ui/button/button.tsx";

export type HrSubmitButtonConfig = {
  label: string;
  variant: ButtonVariant;
};

const DEFAULT_SUBMIT: HrSubmitButtonConfig = { label: "Submit", variant: "accent" };

/** Maps HR question 8 (confirmation recommendation) to submit CTA label + variant. */
export function getHrSubmitButtonConfig(recommendationAnswer: string | undefined): HrSubmitButtonConfig {
  const answer = (recommendationAnswer ?? "").trim().toLowerCase();
  if (answer === "") return DEFAULT_SUBMIT;

  if (answer.includes("improvement plan")) {
    return { label: "Extend", variant: "accent" };
  }

  if (answer.includes("not recommended")) {
    return { label: "Reject", variant: "danger" };
  }

  if (answer === "recommended" || answer.startsWith("recommended")) {
    return { label: "Approve", variant: "success" };
  }

  return DEFAULT_SUBMIT;
}

export function findHrRecommendationQuestionIndex(questions: { sequenceNo: number }[]): number {
  return questions.findIndex((q) => q.sequenceNo === 8);
}

export function isHrExtendRecommendation(recommendationAnswer: string | undefined): boolean {
  const answer = (recommendationAnswer ?? "").trim().toLowerCase();
  return answer.includes("improvement plan");
}
